import { render, staticRenderFns } from "./KBASecurityAnswerDefinitionStage.vue?vue&type=template&id=31b1a8ac&scoped=true"
import script from "./KBASecurityAnswerDefinitionStage.vue?vue&type=script&lang=js"
export * from "./KBASecurityAnswerDefinitionStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b1a8ac",
  null
  
)

export default component.exports